/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import PredictToVizMapping from './PredictToVizMapping';
import _ from 'underscore';

class PredictSpecConverter {
	constructor(options) {
		this._predictToVizMapping = PredictToVizMapping;
		this._modelRef = options.modelRef;
	}

	transformPredictRecommendations(recommendations){
		return recommendations.map( recommendation => {
			return this._transformWidgetRecommendationToLiveWidgetSpec(recommendation);
		});
	}

	collectPredictVisRecommendations(selections){
		let recommendations = [];
		selections.forEach(selection => {
			if (selection && selection.values){
				selection.values.forEach(function(value){
					if (value.payload){
						const vis = _.isArray(value.payload.vis) ? value.payload.vis: [value.payload.vis];
						if (value.payload.fields) {
							vis.forEach((v) => {
								if (v.dataItems) {
									v.dataItems.forEach((dataItem) => {
										const field = value.payload.fields.find((field) => field.id === dataItem.itemId);
										if (field) {
											dataItem.itemLabel = field.label;
										} else {
											if (value.payload.target && value.payload.target.id === dataItem.itemId) {
												dataItem.itemLabel = value.payload.target.label;
											}
										}
									});
								}
							});
						}
						recommendations = recommendations.concat(vis);
					}
				});
			}
		});
		return recommendations;
	}

	_transformWidgetRecommendationToLiveWidgetSpec(recommendation){
		let { dataItems } = recommendation;
		const { chartType, slotmapping, annotations } = recommendation;
		const smartsToVisMap = this._predictToVizMapping[chartType];
		let { slots } = slotmapping;
		slots = this._transformSlopmapping(slots, smartsToVisMap);
		dataItems = this._transformDataItems(dataItems);

		return {
			type: 'live',
			visTypeLocked: true,
			visId: smartsToVisMap.visId,
			data: {
				dataViews: [
					{
						modelRef: this._modelRef,
						dataItems: dataItems
					}
				]
			},
			slotmapping: {
				slots : slots
			},
			annotations: {
				toggleEnabled: annotations && annotations.length > 0,
				selectedAnnotations: annotations || []
			}
		};
	}

	_transformSlopmapping (slots, smartsToVisMap){
		slots.forEach( slot => {
			slot.name = smartsToVisMap[slot.name] ? smartsToVisMap[slot.name]: slot.name;
			slot.layerId = 'data';
		});
		return slots;
	}

	_transformDataItems( dataItems){
		dataItems.forEach( dataItem => {
			const { id, binning } = dataItem;
			if (binning){
				dataItem.binningDefinition = {
					id: id,
					binning: binning
				};
				delete dataItem.binning;
			}
		});
		return dataItems;
	}

}

export default PredictSpecConverter;



// WEBPACK FOOTER //
// ./src/js/util/PredictSpecConverter.js